<template>
  <div class="footbox">
    <div class="phonenum">
      <a
        @click="hotelcatchbdfun(telphone)"
        :href="'tel:' + telphone"
        data-agl-cvt="2"
      >
        <img :src="require('assets/images/phone2.png').default" width="30" />
        点击拨打预定电话：{{ telphone }}</a
      >
    </div>
    <div class="footer">
      <template>
        <div class="index-footer">
          <div class="index-footer-bottom">
            <div class="wbase">
              <p>
                Copyright © 2019-2024&nbsp;&nbsp;版权所有&nbsp;&nbsp;{{
                  getDomainInfo.name
                }}
                &nbsp;&nbsp;&nbsp;&nbsp;<a
                  v-if="getDomainInfo.status == 6"
                  href="https://www.tetuijiudian.com/website/#/about"
                  >关于我们&nbsp;&nbsp;</a
                >
              </p>
              <p class="bottom-center" v-if="getDomainInfo.status == 6">
                <a
                  class="cl"
                  href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
                  target="_blank"
                  >冀ICP备19022489号 </a
                ><span class="line">|</span>
                <a
                  href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
                  target="_blank"
                  >冀ICP备19022489号-1</a
                >
              </p>

              <p>
                若您有任何建议、投诉或网站信息侵权等问题，请反馈我们
                400-6891109，将及时处理。
              </p>
            </div>
          </div>
        </div>
        <p></p>
      </template>
    </div>
    <Confer></Confer>
  </div>
</template>
<script>
import Confer from "components/content/Confer";
export default {
  name: "footerbox",
  data() {
    return {
      isshow: false,
      domainMapData: [],
    };
  },
  created() {
    this.fetchDomainMap();
  },
  components: {
    Confer,
  },
  methods: {
    fetchDomainMap() {
      const cached = localStorage.getItem("domainMapData");
      if (cached) {
        try {
          this.domainMapData = JSON.parse(cached);
          return;
        } catch (e) {}
      }
      fetch("https://csweb.xiaodianjia.cn/h5pay/bookUrl.php")
        .then((res) => res.json())
        .then((result) => {
          if (result.code === 200 && result.data) {
            this.domainMapData = result.data;
            localStorage.setItem("domainMapData", JSON.stringify(result.data));
          }
        })
        .catch((err) => {
          console.error("Failed to fetch domain map:", err);
        });
    },
    hotelcatchbdfun: function (telphone) {
      const url = window.location.href;
      console.log(url);
      const hotelname = this.$store.state.hotelinfro.hotelname;
      const address = this.$store.state.hotelinfro.address;
      const zid = this.$route.query.hid;
      let hidp = "";
      let that = this;
      let referrer = document.referrer;
      let ismobiles = "no";
      if ("ontouchstart" in document.documentElement) {
        ismobiles = "1";
      }
      let loa = encodeURIComponent(location.href);
      let hiddenProperty =
        "hidden" in document
          ? "hidden"
          : "webkitHidden" in document
          ? "webkitHidden"
          : "mozHidden" in document
          ? "mozHidden"
          : null;
      if (document[hiddenProperty]) {
        hidp = "ishide";
      } else {
        hidp = "nohide";
      }
      if (hiddenProperty == null) {
        hidp = "nullhide";
      }
      window.dispatchEvent(
        new CustomEvent("jd:getfunc", {
          detail: {
            zq: $,
            param: {
              type: "get",
              url:
                "https://api.tetuijiudian.com/bdfun.php?fun=bdfunpv&zid=" +
                zid +
                "&hidp=" +
                hidp +
                "&loa=" +
                loa +
                "&ismobiles=" +
                ismobiles +
                "&address=" +
                address +
                "&hotelname=" +
                hotelname +
                "&referrer=" +
                referrer +
                "&wap=0" +
                "&clicktel=" +
                telphone,

              dataType: "json",
              success: function (response) {},
              complete: function () {},
              error: function () {},
            },
          },
        })
      );
    },
    extractDomain(url) {
      const match = url.match(
        /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n]+)/im
      );
      return match ? match[1] : "";
    },
  },
  computed: {
    telphone() {
      return this.$store.state.hotelphone; // 访问 Vuex Store 中的状态
    },
    getDomainInfo() {
      const url = window.location.href;
      const domainMap = this.domainMapData;

      const matched = domainMap.find((item) => url.includes(item.key));

      if (matched) {
        return {
          name: matched.name || "",
          status: matched.status,
          copyright: "版权所有",
        };
      }

      return {
        name: "承德特推酒店管理有限公司",
        status: 6,
        copyright: "版权所有",
      };
    },
  },
};
</script>

<style lang="less">
.footer {
  text-align: center;
  color: #fff;
  font-size: 14px;
  padding: 20px 0;
  width: 100%;

  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 30px;
  background: #3a3c41;
}

.phonenum {
  display: none;
}
.footbox {
  .confer {
    position: fixed;
    border: 1px solid #f1f1f1;

    bottom: 0px;
    right: 0px;
    background: #fff;
    z-index: 1000;
  }
}
.line {
  margin: 0 12px;
}
.cl {
  padding-left: 28px;
  background: url(~@/assets/images/anbei.png) no-repeat left center;
  background-size: contain;
  color: #666;
}
.index-footer a {
  color: #aaa;
}
.index-footer a:hover {
  color: #999;
}
.bottom-bot {
  padding-top: 10px;
}
@media (min-width: 320px) and (max-width: 780px) {
  .footbox {
    position: relative;
    padding-top: 100px;
    z-index: 100000;
    .footer {
      display: none;
    }
  }
  .phonenum {
    display: block;
    width: 100%;
    height: 70px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ff5555;
    color: #fff;
    text-align: center;
    line-height: 70px;
    a {
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      img {
        margin-right: 20px;
      }
    }
  }
}
</style>
 